module.exports = __webpack_public_path__ + "img/unit.da6b503e.svg";